import _ from 'lodash';
import { api } from '_/services/api';
import { config } from '_/config/config';
import { imageTagTemplate } from '~/components/FieldTypes/Redactor/Redactor.imageTagTemplate';
import { pError } from '_/helpers/logger';
import { store } from '_/vuex/store';

(function ($) {
    $.Redactor.prototype.editPhotonImage = function () {
        return {
            /**
             * Defines the template for the modal window
             *
             * @return  {string}
             */
            getTemplate() {

                let photonImageAlignmentOptions = `<option value="article-photo pull-left">${this.lang.get(
                    'align-left'
                )}</option>`;

                photonImageAlignmentOptions += `<option value="article-photo" selected>${this.lang.get(
                    'center'
                )}</option>`;

                photonImageAlignmentOptions += `<option value="article-photo pull-right">${this.lang.get(
                    'align-right'
                )}</option>`;

                return (
                    String() +
                    '<div class="redactor-modal-tab redactor-group" data-title="General">' +
                    '<div id="photon-image-preview" class="redactor-modal-tab-side">' +
                    '</div>' +
                    '<div class="redactor-modal-tab-area">' +
                    '<input type="hidden" id="photon-asset-id" value=""/>' +
                    '<input type="hidden" id="photon-file_url" value=""/>' +
                    '<section>' +
                    '<button id="redactor-modal-button-change-photo">' +
                    this.lang.get('change-photo') +
                    '</button>' +
                    '</section>' +

                    '<section>' +
                    '<label class="redactor-image-position-option">' +
                    this.lang.get('image-alignment') +
                    '</label>' +
                    '<select class="redactor-image-position-option" id="photon-image-alignment" aria-label="' +
                    this.lang.get('image-alignment') +
                    '">' +
                    photonImageAlignmentOptions +
                    '</select>' +
                    '</section>' +
                    '<section>' +
                    '<label>' +
                    this.lang.get('title') +
                    '</label>' +
                    '<input type="text" id="photon-image-title" />' +
                    '</section>' +
                    '<section>' +
                    '<label>' +
                    this.lang.get('source') +
                    '</label>' +
                    '<input type="text" id="photon-image-source" />' +
                    '</section>' +
                    '<section>' +
                    '<label>' +
                    this.lang.get('link') +
                    '</label>' +
                    '<input type="text" id="photon-image-link" />' +
                    '</section>' +
                    '<section>' +
                    '<button id="redactor-modal-button-save">' +
                    this.lang.get('save') +
                    '</button>' +
                    '<button id="redactor-modal-button-cancel">' +
                    this.lang.get('cancel') +
                    '</button>' +
                    '<button id="redactor-modal-button-delete" class="redactor-modal-button-offset">' +
                    this.lang.get('delete') +
                    '</button>' +
                    '</section>' +
                    '</div>' +
                    '</div>'
                );
            },

            /**
             * Stores available image sizes objects
             *
             * @type  {Array}
             */
            imageSizes: [],

            /**
             * Redactor plugin Init method, ran as the constructor
             *
             * @return  {void}
             */
            init() {
                $(this.$editor).click((event) => {
                    if (!$(event.target).is('img')) {
                        return;
                    }

                        // Since image sizes concept was removed, we'll just show the modal directly
                    this.editPhotonImage.show(event);
                });
            },

            /**
             * Removes the image from the editor HTML
             *
             * @return  {[type]}  [description]
             */
            remove($photonImageCodeSnippet) {
                $photonImageCodeSnippet.remove();

                this.modal.close();

                this.buffer.set();

                this.code.sync();
            },

            /**
             * Performs the update of the code as per parameters set in the modal window
             *
             * @return  {void}
             */
            save($photonImageCodeSnippet) {
                const assetId = $('#photon-asset-id').val();

                api.get(`assets/${assetId}`, '', [], { Locales: store.state.ui.localesHeaderParameter, Depth: '1' })
                    .then((response) => {
                        let asset = response.body.body.entry;

                        // Always use original image since image sizes concept was removed
                        asset['imageSizeId'] = 'original';

                        asset['imageAlignment'] = $('#photon-image-alignment').val();

                        asset['fields']['source'] = {
                            anchor_text: $('#photon-image-source').val(),
                        };

                        asset['fields']['link'] = {
                            anchor_text: $('#photon-image-link').val(),
                        };

                        // Get the default locale from the store
                        const defaultLocale = store.state.ui.defaultLocale.languageCode;
                        
                        // Set the title with the proper locale structure
                        if (!asset['fields']['title']) {
                            asset['fields']['title'] = {};
                        }
                        asset['fields']['title'][defaultLocale] = $('#photon-image-title').val();

                        const tempId = `image-tag-${moment().valueOf()}`;

                        const template = imageTagTemplate(asset, tempId);

                        $photonImageCodeSnippet.replaceWith(template);

                        this.modal.close();

                        this.buffer.set();

                        this.code.sync();
                    })
                    .catch((response) => {
                        pError('Failed to load asset details from the API.', response);
                    });
            },

            /**
             * Reveals the modal window
             *
             * @param   {event}  event
             * @return  {void}
             */
            show(event) {
                const $image = $(event.target);

                const fileUrl = $image.attr('src');

                const title = $image.attr('alt');

                const assetId = $image.data('assetId');

                const imageSizeId = $image.data('imageSizeId');

                const imageAlignment = $image.data('imageAlignment');

                const $photonImageCodeSnippet = $image.parent();

                const $source = $photonImageCodeSnippet.find('span');

                const $link = $photonImageCodeSnippet;

                this.modal.addTemplate('editPhotonImage', this.editPhotonImage.getTemplate());

                this.modal.load('editPhotonImage', this.lang.get('edit-image'), 705);

                $('#photon-asset-id').val(assetId);

                $('#photon-file_url').val(fileUrl);

                $('#photon-image-preview').html($('<img src="' + $image.attr('src') + '" style="max-width: 100%;">'));

                // Image size dropdown has been removed, we always use original

                $('#photon-image-alignment').val(imageAlignment);

                // Always set the title from the alt attribute
                $('#photon-image-title').val(title || '');

                if ($source) {
                    $('#photon-image-source').val($source.text());
                }

                if ($photonImageCodeSnippet[0]['localName'] === 'a') {
                    $('#photon-image-link').val($photonImageCodeSnippet.attr('href'));
                }

                $('#redactor-modal-button-save').on('click', () => {
                    this.editPhotonImage.save($photonImageCodeSnippet);
                });

                $('#redactor-modal-button-delete').on('click', () => {
                    this.editPhotonImage.remove($photonImageCodeSnippet);
                });

                $('#redactor-modal-button-change-photo').on('click', () => {
                    this.opts.Vue.openAssetsManager();
                });

                this.modal.show();

                if (this.detect.isDesktop()) {
                    $('#photon-image-title').focus();
                }
            },

            /**
             * Language object, to be used with Redactor native translation system
             *
             * @type  {Object}
             */
            langs: {
                en: {
                    'align-center': 'Align center',
                    'align-left': 'Align left',
                    'align-right': 'Align right',
                    cancel: 'Cancel',
                    'change-photo': 'Change photo',
                    delete: 'Delete',
                    'edit-image': 'Edit Image',
                    'image-alignment': 'Image alignment',
                    'image-size': 'Image size',
                    insert: 'Insert',
                    save: 'Save',
                    source: 'Source',
                    title: 'Title',
                },
            },
        };
    };
})(jQuery);
